const state = {
	// Информация для формы - Оплата (каналы)
	payChannelDetailState: {},

	// Покупка каналов
	payChannelState: {},

	// Пополнение
	payBalanceState: {},

	// Успешное пополнение
	paySuccessState: {},

	// Оплата не прошла
	payFailState: {},

	// Количество активированных каналов
	payActivatedChannelsState: { count: 0 },

	// Баланс партнера
	payGetBalanceState: 0,

	// История покупок
	payHistoryState: [],

	// Покупка опций
	payOptionsState: {},

	// Покупка опций прошла успешно
	payOptionsSuccessState: {},

	// Связь опций с инстансом
	payOptionsLnkInstanceState: [],

	// Автопродление опции (для checkbox)
	autoRenewalOptionState: {},

	// Продление опций
	payOptionsRenewalState: {},
};

export default state;
